import { IState } from '../../store';

export const selectIsApartment = (state: IState): boolean => state.offerData.offer.isApartments || false;
